export enum InvoiceImageKeys {
  PERSPECTIVE = 'perspective',
  PERSPECTIVE_BACK = 'perspective-back',
  FRONT = 'front',
  BACK = 'back',
  LEFT = 'left',
  RIGHT = 'right',
  PERSPECTIVE_INTERIOR = 'perspective-interior',
  PERSPECTIVE_BACK_INTERIOR = 'perspective-back-interior',
  FRONT_INTERIOR = 'front-interior',
  BACK_INTERIOR = 'back-interior',
  LEFT_INTERIOR = 'left-interior',
  RIGHT_INTERIOR = 'right-interior',
}
